//计算倒计时时间
export default function countdown(sec) {
    sec = Number(sec);

    if (sec <= 0) {
        return { _day: '00', _hours: '00', _minutes: '00', _seconds: '00' };
    }

    // 总秒值
    let _allSeconds = parseInt(sec, 10);

    // 计算 天，时，分，秒
    let _day     = parseInt( _allSeconds/(60*60*24), 10 );
    let _hours   = parseInt( _allSeconds /60 / 60 % 24, 10 );
    let _minutes = parseInt( _allSeconds /60 % 60, 10);
    let _seconds = parseInt( _allSeconds % 60, 10);

    // 小于10，前面加0
    _day     = _day     < 10 ? `0${_day}`     : _day;
    _hours   = _hours   < 10 ? `0${_hours}`   : _hours;
    _minutes = _minutes < 10 ? `0${_minutes}` : _minutes;
    _seconds = _seconds < 10 ? `0${_seconds}` : _seconds;
    return { _day, _hours, _minutes, _seconds };
}


// WEBPACK FOOTER //
// ./src/tools/countdown.js